import React, { Component } from "react";

import { tables } from "constants/tables";
import { materialTableProps } from "utils";
import { isUndefined } from "util";

import MaterialTable, { MTableBody } from "@material-table/core";
import { Icon } from "antd";

import { selectService } from "services";
import { MTableAction } from "material-table";
import { connect } from "react-redux";
import PowerBiPopUp from "./PowerBiPopUp";

// Gestionnaire de tableau.
// Utilise MaterialTable. Les props proviennent du utils/props,
// les infos des colonnes de constants/tables.
class Table extends Component {
  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
    this.state = { table: null };

    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleFiltersReset = this.handleFiltersReset.bind(this);
  }

  componentDidMount() {
    const { type, filters: fixedFilters } = this.props;
    var table = tables[type];

    //Vérifie si le bouton import_export doit être afficher pour powerbi
    //Todo: changer pour le rank admin après les tests au lieu du user id
    if (table.actions && this.props.currentUser.id !== 1) {
      let index = table.actions.map((e) => e.icon).indexOf("import_export");
      if (index !== -1) table.actions.splice(index, 1);
    }

    // Setup des filtres prédéfinis
    const filters = JSON.parse(localStorage.getItem(`filters[${type}]`));
    const toHide = JSON.parse(localStorage.getItem(`hidden_columns[${type}]`));

    table.columns = table.columns.map((c) => {
      var field = c.field;
      if (filters && field in filters) c.defaultFilter = filters[field];
      if (toHide && field in toHide && !isUndefined(toHide[field])) c.hidden = toHide[field];

      if (fixedFilters && field in fixedFilters) c.filtering = false;

      return c;
    });

    this.setState({ table: table });

    // Fetch des Lookups
    selectService
      .listForPage(type)
      .then((result) => {
        (Object.keys(result) || []).map((key) => {
          var columns = [...table.columns];
          var target = columns.find((c) => c.lookupKey === key);
          if (target) {
            result[key].map((lookup) => {
              target.lookup[lookup.id] = lookup.label;
            });
            target.lookupOrder = result[key].map((lookup) => String(lookup.id));
            this.setState({
              table: { ...table, columns: columns },
            });
          }
        });
      })
      .catch((e) => {
        this.setState(() => {
          throw new Error(e);
        });
      });
  }

  // Fonction de pagination qui refetch les données.
  handlePagination(query) {
    const { filters } = this.props;
    const { table } = this.state;
    if (!table) return <></>;

    this.setState({
      pagination: {
        page: window.history?.state?.page ?? query.page + 1,
        pageSize: window.history?.state?.pageSize ?? query.pageSize,
        orderby: window.history?.state?.orderBy ?? query.orderBy,
        orderDirection: window.history?.state?.orderDirection ?? query.orderDirection,
      },
    });

    return new Promise(function (resolve, reject) {
      var fetcher = "fetcher" in table ? table.fetcher : "list";
      if (filters) {
        for (var key in filters)
          query.filters.push({
            column: { field: key },
            operator: "=",
            value: filters[key],
          });
      }
      // if (query.pageSize === 'ALL') query.pageSize = 100000;
      table.service[fetcher](query.filters, {
        pnum: window.history?.state?.page ?? query.page + 1,
        per: window.history?.state?.pageSize ?? query.pageSize,
        orderby: window.history?.state?.orderBy ?? query.orderBy,
        dir: window.history?.state?.orderDirection ?? query.orderDirection,
      })
        .then((result) => {
          let data = result.data;
          if ("dataFormat" in table) data = table.dataFormat(data);

          resolve({
            data,
            page:
              result.total_pages > result.page
                ? result.page - 1
                : result.total_pages === 0
                  ? 0
                  : result.total_pages - 1,
            totalCount: result.total,
          });
        })
        .catch((e) => {
          reject(e);
        });

      //Window.scrollPosition?
      if (window.history?.state?.id) {
        setTimeout(() => {
          const elements = document.getElementsByTagName("tr");
          let int = [...elements]
            ?.map((elem) => elem.getAttribute("index") === window.history.state.id.toString())
            .indexOf(true);
          if (int !== -1) elements[int].scrollIntoView();
          // window.history.replaceState({}, '');
        }, 1000);
      }
    });
  }

  // Caching des filtres.
  handleFilterChange(action, column, value) {
    const { type } = this.props;
    const filters = JSON.parse(localStorage.getItem(`${action}[${type}]`));
    //If this.state.columns[column].filtersValue() ? this.state.columns[column].filtersValue()  : column
    const updated = { ...filters, [column]: value };
    localStorage.setItem(`${action}[${type}]`, JSON.stringify(updated));
    window.history.replaceState({}, "");
  }

  // Reset des filtres cachés.
  handleFiltersReset() {
    const { type } = this.props;
    localStorage.removeItem(`filters[${type}]`);
    localStorage.removeItem(`hidden_columns[${type}]`);
    window.location.reload();
    window.history.replaceState({}, "");
  }

  render() {
    const { table, loading } = this.state;
    if (!table) return <></>;

    const editable = "editable" in table ? table.editable : {};

    return (
      <div className="table-wrap">
        {this.props.title && <h2>{this.props.title}</h2>}
        <span className="reload-filters-btn" onClick={this.handleFiltersReset}>
          <Icon type="reload" />
          Réinitialiser les filtres
        </span>

        <MaterialTable
          tableRef={this.tableRef}
          title={table.title}
          columns={table.columns}
          data={(query) => this.handlePagination(query)}
          {...materialTableProps(
            table.title,
            table.columns,
            this.tableRef,
            window?.history?.state?.pageSize ?? 10,
          )}
          onRowClick={(e, data) => {
            if (this.state.table.title === "CLB - Soumissions") {
              const { pagination } = this.state;
              window.history.pushState(
                {
                  id: e.target.parentElement.getAttribute("index"),
                  page: pagination.page,
                  pageSize: pagination.pageSize,
                  orderBy: pagination.orderBy,
                  orderDirection: pagination.orderDirection,
                },
                "",
              );
            }
            return "onRowClick" in table ? table.onRowClick(e, data) : "";
          }}
          actions={table.actions}
          onChangeColumnHidden={(column, hidden) =>
            this.handleFilterChange("hidden_columns", column.field, hidden)
          }
          components={{
            Action: (props) => {
              //Vérifie si l'action correspond au popup pour power bi
              if (props.action.icon === "import_export") {
                return <PowerBiPopUp table={this.state.table} />;
              } else {
                return <MTableAction {...props}></MTableAction>;
              }
            },
            Body: (props) => (
              <MTableBody
                {...props}
                onFilterChanged={(id, value) => {
                  props.onFilterChanged(id, value);
                  this.handleFilterChange("filters", props.columns[id].field, value);
                }}
              />
            ),
          }}
          editable={{ ...editable }}
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    currentUser: state.user.infos || {},
  };
};

export default connect(mapStateToProps, null)(Table);
